class TrTabs extends HTMLElement {
	selectors = {
		tab: '[data-tr-js-tabs-tab]',
		target: '[data-tr-js-tabs-target]'
	};

	attributes = {
		tabId: 'data-tr-js-tabs-tab',
		targetId: 'data-tr-js-tabs-target'
	};

	stateClasses = {};

	connectedCallback() {
		this.tabElements = Array.from(this.querySelectorAll(this.selectors.tab));
		this.targetElements = Array.from(this.querySelectorAll(this.selectors.target));

		this.init();
		this.bindEvents();

		document.addEventListener('shopify:section:load', this.onSectionLoad);
		document.addEventListener('shopify:block:select', this.onBlockSelect);
	}

	disconnectedCallback() {
		document.removeEventListener('shopify:section:load', this.onSectionLoad);
		document.removeEventListener('shopify:block:select', this.onBlockSelect);

		this.destroy();
	}

	init() {
		const selectedTabElement = this.tabElements.find(
			(tabElement) => tabElement.getAttribute('aria-selected') === 'true'
		);

		if (selectedTabElement) {
			this.activateTab(selectedTabElement, false);
		} else if (this.tabElements[0]) {
			this.activateTab(this.tabElements[0], false);
		}
	}

	bindEvents() {
		this.tabElements.forEach((tabElement) => {
			tabElement.addEventListener('click', this.onTabClick);
			tabElement.addEventListener('keydown', this.onTabKeydown);
		});
	}

	onSectionLoad = (event) => {
		if (!this.closest(`#shopify-section-${event.detail.sectionId}`)) return;

		this.init();
	};

	onBlockSelect = (event) => {
		const tabElement = this.tabElements.find(
			(element) => element.dataset.blockId === event.detail.blockId
		);

		if (!tabElement) return;

		this.activateTab(tabElement, false);
	};

	onTabClick = (event) => {
		this.activateTab(event.currentTarget);
	};

	onTabKeydown = (event) => {
		const currentIndex = this.tabElements.indexOf(event.currentTarget);
		let nextIndex = currentIndex;

		if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
			nextIndex = (currentIndex + 1) % this.tabElements.length;
		} else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
			nextIndex = (currentIndex - 1 + this.tabElements.length) % this.tabElements.length;
		} else if (event.key === 'Home') {
			nextIndex = 0;
		} else if (event.key === 'End') {
			nextIndex = this.tabElements.length - 1;
		} else {
			return;
		}

		event.preventDefault();
		this.activateTab(this.tabElements[nextIndex]);
	};

	activateTab(tabElement, moveFocus = true) {
		const activeTabId = tabElement.getAttribute(this.attributes.tabId);

		this.tabElements.forEach((element) => {
			const isActive = element === tabElement;

			element.setAttribute('aria-selected', String(isActive));
			element.tabIndex = isActive ? 0 : -1;
		});

		this.targetElements.forEach((targetElement) => {
			const isActive = targetElement.getAttribute(this.attributes.targetId) === activeTabId;

			targetElement.hidden = !isActive;
		});

		if (moveFocus) tabElement.focus();
	}

	destroy() {
		this.tabElements.forEach((tabElement) => {
			tabElement.removeEventListener('click', this.onTabClick);
			tabElement.removeEventListener('keydown', this.onTabKeydown);
		});
	}
}

if (!customElements.get('tr-tabs')) {
	customElements.define('tr-tabs', TrTabs);
}
